import { ProposalInterviewType, ProposalStatus } from "./types";

export const ProposalStatusText: Record<ProposalStatus, string> = {
  [ProposalStatus.PENDING]: "Menunggu Jawaban",
  [ProposalStatus.REVIEWED]: "Sedang Dipelajari",
  [ProposalStatus.INTERVIEWED]: "Wawancara",
  [ProposalStatus.ACCEPTED]: "Lamaran Diterima",
  [ProposalStatus.REJECTED]: "Ditolak",
  [ProposalStatus.CANCELED]: "Dibatalkan",
};

export const ProposalInterviewTypeText: Record<ProposalInterviewType, string> = {
  [ProposalInterviewType.WALK_IN]: "Ditempat",
  [ProposalInterviewType.VIDEO_CALL]: "Online",
};